import React from "react";
import Hero from "../components/Hero";
import HeroTestimonial from "../components/HeroTestimonial";
import ITSupportSection from "../components/ITSupportSection";
import ServicesGrid from "../components/ServicesGrid";
import WhyChooseUs from "../components/WhyChooseUs";
import Reviews from "../components/Reviews";
import CTABanner from "../components/CTABanner";
import ContactSection from "../components/ContactSection";
import FAQ from "../components/FAQ";

const Home = () => {
  return (
    <>
      <Hero />
      <HeroTestimonial />
      <ITSupportSection />
      <ServicesGrid compactHome />
      <WhyChooseUs />
      <Reviews />
      <FAQ />
      <CTABanner />
      <ContactSection />
    </>
  );
};

export default Home;
